export function Singleton<
  Class extends { new (...args: any[]): unknown; scope?: string },
>(t: Class) {
  t.scope = "SINGLETON";
}

export default function Inject(injectable: unknown) {
  return (
    target: object & { _injectArguments_?: unknown[] },
    _propertyKey: string | symbol | undefined,
    parameterIndex: number,
  ): void => {
    target._injectArguments_ = target._injectArguments_ ?? [];
    target._injectArguments_[parameterIndex] = {
      cls: injectable,
      parameterIndex,
    };
  };
}
